/**
 * PlusIcon - Plus für die Titlebar (Schnelleingabe, #256)
 *
 * Im Strich der Lupe (`SearchIcon`), damit die Nachbarn gleich schwer wirken.
 *
 * @example
 * ```tsx
 * <PlusIcon />
 * ```
 */
export const PlusIcon = ({ size = 14 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 1.67V12.33M1.67 7H12.33"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
      />
    </svg>
  )
}
